document.getElementById("company-logo").addEventListener("submit", function (e) {
  e.preventDefault(); // Stop form from submitting normally
  // Optionally validate form or perform AJAX login here
  window.location.href = "lobby.html"; // Redirect to lobby.html
});
